'use client';

import React, { useMemo } from 'react';

import { Column, LabelMedium } from '@dh/styles';
import { useTheme } from '@dh/hooks';
import { keyboardSelect } from '@dh/utils/keyboardSelect';

import { SmallSideNavItemButton, SmallSidenavItemStack } from './styles';

type Props = {
    icon?: React.JSX.Element;
    label: string;
    selectedIcon?: React.JSX.Element;
    isSelected: boolean;
    handleOnClick: () => void;
};

export const SmallSidenavItem = React.memo<Props>(
    ({ icon, label, selectedIcon, isSelected, handleOnClick }: Props) => {
        const theme = useTheme();

        // Memoize the icon to display
        const displayedIcon = useMemo(
            () => (isSelected && selectedIcon ? selectedIcon : (icon ?? null)),
            [isSelected, selectedIcon, icon]
        );

        return (
            <SmallSidenavItemStack
                isSelected={isSelected}
                onClick={handleOnClick}
                onKeyDown={(event) => {
                    keyboardSelect(event, handleOnClick);
                }}
                tabIndex={0}
                aria-label={`Navigation-Item-${label}`}
            >
                <Column sx={{ alignItems: 'center' }} gap={0.5}>
                    <SmallSideNavItemButton isSelected={isSelected} tabIndex={-1}>
                        {displayedIcon}
                    </SmallSideNavItemButton>
                    <LabelMedium color={theme.colors.surfaceVariant}>{label}</LabelMedium>
                </Column>
            </SmallSidenavItemStack>
        );
    }
);

SmallSidenavItem.displayName = 'SmallSidenavItem';
